import React from 'react';
import { useState } from 'react';
import BarChart from './Bar';
import PieChart from './Pie';
import LineChart from './Line';
import axios from 'axios';
import config from '../config.js';
import { useDarkMode } from '../contexts/DarkModeContext';

const Chart = (props) => {
    const { isDarkMode } = useDarkMode();
    const data = props.data;
    const keys = Object.keys(data[0]);
    const [chartType, setChartType] = useState("bar");
    const [xAxis, setXAxis] = useState(keys[0]);
    const [yAxis, setYAxis] = useState(keys[1]);
    const [isLoading, setIsLoading] = useState(false);

    const serviceUrl_getGraphData = `${config.serviceUrl}/get-graph-data`
    const getGraphData = async () => {

        const requestBody = { "source": props.source, "xAxis": xAxis, "yAxis": yAxis, };
        try {
            setIsLoading(true);
            const config_home = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            };
            const response = await axios.post(serviceUrl_getGraphData, requestBody, config_home);
            props.setChartData(response.data.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const hasChartData = props.chartData && props.chartData.length > 0;

    return (
        <div className={`rounded-xl mx-2 my-1 transition-all ${
            isDarkMode 
                ? 'bg-slate-800/20 shadow-[0_1px_3px_rgba(0,0,0,0.12)]' 
                : 'bg-white border border-slate-200/60 shadow-[0_2px_8px_rgba(0,0,0,0.05)]'
        }`}>
            <div className="flex flex-wrap gap-2 p-3">
                <select
                    className={`px-3 py-2 pr-8 rounded-lg transition-all appearance-none bg-no-repeat bg-right ${
                        isDarkMode 
                            ? 'bg-slate-700/20 text-slate-200 hover:bg-slate-700/40 focus:bg-slate-700/40 focus:outline-none focus:ring-1 focus:ring-slate-600/30' 
                            : 'bg-slate-50/90 border border-slate-200/80 text-gray-900 hover:bg-slate-100 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50'
                    }`}
                    style={{
                        minWidth: chartType === 'doughnut' || chartType === 'pie' ? '160px' : '140px',
                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='${isDarkMode ? '%23cbd5e1' : '%23374151'}' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                        backgroundPosition: 'right 0.75rem center',
                    }}
                    value={chartType}
                    onChange={(e) => { setChartType(e.target.value); }}
                >
                    <option value="bar">Bar Chart</option>
                    <option value="line">Line Chart</option>
                    <option value="pie">Pie Chart</option>
                    <option value="doughnut">Doughnut Chart</option>
                </select>
                <select
                    className={`flex-1 min-w-[100px] px-3 py-2 pr-8 rounded-lg transition-all appearance-none bg-no-repeat bg-right ${
                        isDarkMode 
                            ? 'bg-slate-700/20 text-slate-200 hover:bg-slate-700/40 focus:bg-slate-700/40 focus:outline-none focus:ring-1 focus:ring-slate-600/30' 
                            : 'bg-slate-50/90 border border-slate-200/80 text-gray-900 hover:bg-slate-100 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50'
                    }`}
                    style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='${isDarkMode ? '%23cbd5e1' : '%23374151'}' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                        backgroundPosition: 'right 0.75rem center',
                    }}
                    value={xAxis}
                    onChange={(e) => { setXAxis(e.target.value); }}
                >
                    {keys.map((k) => {
                        return (
                            <option key={k} value={k}>{k}</option>
                        )
                    })}
                </select>
                <select
                    className={`flex-1 min-w-[100px] px-3 py-2 pr-8 rounded-lg transition-all appearance-none bg-no-repeat bg-right ${
                        isDarkMode 
                            ? 'bg-slate-700/20 text-slate-200 hover:bg-slate-700/40 focus:bg-slate-700/40 focus:outline-none focus:ring-1 focus:ring-slate-600/30' 
                            : 'bg-slate-50/90 border border-slate-200/80 text-gray-900 hover:bg-slate-100 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50'
                    }`}
                    style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='${isDarkMode ? '%23cbd5e1' : '%23374151'}' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                        backgroundPosition: 'right 0.75rem center',
                    }}
                    value={yAxis}
                    onChange={(e) => { setYAxis(e.target.value); }}
                >
                    {keys.map((k) => {
                        return (
                            <option key={k}>{k}</option>
                        )
                    })}
                </select>
                <button
                    className={`px-6 py-2 rounded-lg font-medium transition-all ${
                        isLoading || xAxis === undefined || yAxis === undefined
                            ? (isDarkMode 
                                ? 'bg-slate-700/20 text-slate-500 cursor-not-allowed opacity-50' 
                                : 'bg-gray-100 border border-gray-300 text-gray-400 cursor-not-allowed opacity-50')
                            : (isDarkMode 
                                ? 'bg-slate-700/20 text-slate-200 hover:bg-slate-700/40 shadow-[0_1px_3px_rgba(0,0,0,0.12)]' 
                                : 'bg-slate-50/90 border border-slate-200/80 text-gray-700 hover:bg-slate-100 shadow-[0_2px_8px_rgba(0,0,0,0.05)]')
                    }`}
                    onClick={getGraphData}
                    disabled={isLoading || xAxis === undefined || yAxis === undefined}
                >
                    {isLoading && (
                        <span className={`inline-block w-4 h-4 border-2 rounded-full animate-spin mr-2 ${
                            isDarkMode ? 'border-slate-600 border-t-slate-400' : 'border-gray-300 border-t-gray-600'
                        }`} role="status" aria-hidden="true"></span>
                    )}
                    Go
                </button>
            </div>

            {hasChartData && (
                <>
                    {chartType === 'bar' && <BarChart data={props.chartData} x={xAxis} y={yAxis} isDarkMode={isDarkMode} />}
                    {chartType === 'line' && <LineChart data={props.chartData} x={xAxis} y={yAxis} isDarkMode={isDarkMode} />}
                    {chartType === 'pie' && <PieChart data={props.chartData} x={xAxis} y={yAxis} isDarkMode={isDarkMode} />}
                    {chartType === 'doughnut' && <PieChart data={props.chartData} x={xAxis} y={yAxis} doughnut={1} isDarkMode={isDarkMode} />}
                </>
            )}
        </div>
    );
};
export default Chart;